import { render, staticRenderFns } from "./package-component.vue?vue&type=template&id=a9888fea"
import script from "./package-component.vue?vue&type=script&lang=js"
export * from "./package-component.vue?vue&type=script&lang=js"
import style0 from "./package-component.vue?vue&type=style&index=0&id=a9888fea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports